import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const isWeblinkDisabledBlockByDefault: boolean = isFeature('weblink-disabled-block-by-default') ?? false;
